import { useHandlers } from './useHandlers'

export const useContextMenuCreateOrEdit = () => {
  const { data, handlers, state } = useHandlers()

  return {
    data: { ...data },
    state: { ...state },
    handlers: { ...handlers },
  }
}
